import { useTenantStore } from '@/stores/tenant-store';

/**
 * Hook to access the current tenant ID from Zustand store.
 * Works for both authenticated and pre-auth scenarios.
 *
 * @returns The tenant ID if in tenant context, null if in platform context
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const tenantId = useTenant();
 *   // tenantId is string when on tenant domain, null when on platform (localhost)
 * }
 * ```
 */
export function useTenant(): string | null {
  return useTenantStore((state) => state.tenantId);
}
